import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment-timezone";
import { useTranslation } from "react-i18next";

const TimeDisplay = ({ timeMargine = 0, format = "YYYY-MM-DD HH:mm:ss" }) => {
  const { timezone_name } = useSelector((state) => state.user.user);
  const [currentTime, setCurrentTime] = useState("");
  const { t } = useTranslation("components");

  useEffect(() => {
    if (!timezone_name) return;

    setCurrentTime(moment.tz(timezone_name).format(format));

    const interval = setInterval(() => {
      setCurrentTime(moment.tz(timezone_name).format(format));
    }, 1000);

    return () => clearInterval(interval);
  }, [timezone_name, format]);

  if (!timezone_name || !currentTime) {
    return null;
  }

  return (
    <div className={`time-display ${timeMargine != 0 ? `mr-${timeMargine}` : ""}`}>
      <span className="current-time">{t("timeDisplay.currentTime", { time: currentTime })}</span>
      
      {/* --- Eye Icon Section --- */}
      <div className="info-icon-wrapper">
        <svg
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="none"
    stroke="white" /* Icon color white */
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="info-icon-svg"
  >
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="16" x2="12" y2="12"></line>
    <line x1="12" y1="8" x2="12.01" y2="8"></line>
  </svg>
        
        <div className="hover-tooltip-box">
          {t("timeDisplay.tooltip")}
        </div>
      </div>
      {/* ----------------------- */}
    </div>
  );
};

export default TimeDisplay;